import { PropfirmOfferService } from '@/service/propfirm-offer/propfirm-offer';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const KEY = ['PropfirmOfferService.overrides'];

/// Les corrections ne bougent qu'à la main d'un admin : relues au plus toutes
/// les dix minutes, et gardées en cache pour que le catalogue corrigé ne
/// retombe jamais sur l'embarqué entre deux pages.
export const useGetPropfirmOfferOverridesQuery = () =>
  useQuery({
    queryFn: PropfirmOfferService.overrides,
    queryKey: KEY,
    staleTime: 10 * 60_000,
    gcTime: Infinity,
  });

export const useSavePropfirmOfferOverrideMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PropfirmOfferService.save,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
};

export const useResetPropfirmOfferOverrideMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PropfirmOfferService.reset,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
};

const PARTNERS_KEY = ['PropfirmOfferService.partners'];

/// Comme les corrections : ne bougent qu'à la main d'un admin.
export const useGetComparatorPartnersQuery = () =>
  useQuery({
    queryFn: PropfirmOfferService.partners,
    queryKey: PARTNERS_KEY,
    staleTime: 10 * 60_000,
    gcTime: Infinity,
  });

export const useSaveComparatorPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PropfirmOfferService.savePartner,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PARTNERS_KEY }),
  });
};

export const useResetComparatorPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PropfirmOfferService.resetPartner,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PARTNERS_KEY }),
  });
};
